"use client"

import { useState } from "react"
import { v4 as uuidv4 } from 'uuid';
import portfolio from "../Images/Projects/Portfolio.png"
import ast from "../Images/Projects/ast.png"
import swi from "../Images/Projects/Swiftconveter.png"
import swiftlink from "../Images/Projects/SwiftLink.png"
import finance from "../Images/Projects/Poultry Finance.png"
import planner from "../Images/Projects/SwiftPlanner.png"
import katha1 from "../Images/Projects/KathaKaalaamsam.png"
import swiftvault from "../Images/Projects/SwiftVault.png"
import katha from "../Images/Projects/katha.png"

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState("All")

  const projectsData = [
    {
      id: uuidv4(),
      title: "Swift Vault",
      description:
        "Developed a secure password and environment variable manager for developers and teams. Features AES-GCM encrypted storage, project-scoped folders, and deliberate secret reveal flows, built with Next.js, Drizzle ORM, and Supabase.",
      image: swiftvault,
      liveUrl: "https://vault.swiftproject.in/",
      color: "#03a9f4",
      category: "Tools",
    },
    {
      id: uuidv4(),
      title: "KathaKaalaamsam V-2.0",
      description: (
        <>
          Built a CRUD app for a podcasting friend to upload story writings, vocals, and podcasts linked to Instagram & Spotify. This is a version upgrade of{' '}
          <a
            href="https://katha-kaalaamsam.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline' }}
          >
            KathaKaalaamsam V1
          </a>.
        </>
      ),
      image: katha1,
      liveUrl: "https://kathakaalaamsam.vercel.app/",
      color: "#03a9f4",
      category: "Web Apps",
    },
    {
      id: uuidv4(),
      title: "Swift Planner",
      description:
        "Developed a student productivity platform with integrated modules for task management, smart reminders, digital note-taking, and personal finance tracking — streamlining academic and personal organization in one unified interface.",
      image: planner,
      liveUrl: "https://swiftplanner.vercel.app/",
      color: "#03a9f4",
      category: "Tools",
    },
    {
      id: uuidv4(),
      title: "Poultry Finance",
      description:
        "Developed a comprehensive financial management solution for poultry businesses, offering expense tracking, revenue analysis, and financial reporting to help farmers optimize their operations and profitability.",
      image: finance,
      liveUrl: "https://farmfinance.netlify.app/",
      color: "#03a9f4",
      category: "Web Apps",
    },
    {
      id: uuidv4(),
      title: "Swift Linker",
      description:
        "Developed Swift Link to deliver a fast and intuitive URL shortening experience, enabling users to create clean, customizable, and shareable links effortlessly—streamlining link management.",
      image: swiftlink,
      liveUrl: "https://swiftlinker.netlify.app/",
      color: "#03a9f4",
      category: "Tools",
    },
    {
      id: uuidv4(),
      title: "Swift Converter",
      description:
        "Developed SwiftConverter to provide a seamless file conversion (Image,Video,Audio) experience with a user-friendly interface, simplifying format transformations and boosting productivity.",
      image: swi,
      liveUrl: "http://swiftconvert.vercel.app/",
      color: "#03a9f4",
      category: "Tools",
    },
    {
      id: uuidv4(),
      title: "AST Web Compiler",
      description:
        "Developed AST IDE to offer a streamlined coding environment with an intuitive interface, enhancing productivity and ease of use for developers.",
      image: ast,
      liveUrl: "https://ast-ide.vercel.app/",
      color: "#03a9f4",
      category: "Web Apps",
    },
    {
      id: uuidv4(),
      title: "Personal Portfolio",
      description:
        "My portfolio presents another design exemplifying my diverse skill set and creative prowess, demonstrating proficiency, attention to detail, and innovative thinking in every project.",
      image: portfolio,
      liveUrl: "https://sriram-tech.vercel.app",
      color: "#03a9f4",
      category: "Web Apps",
    },
    {
      id: uuidv4(),
      title: "Katha-Kaalaamsam",
      description:
        "Designed Katha-Kaalaamsam as a storytelling platform for my friends, combining clean design with a smooth user experience to bring their ideas to life.",
      image: katha,
      liveUrl: "https://katha-kaalaamsam.vercel.app/",
      color: "#03a9f4",
      category: "Web Apps",
    },
  ]

  const filterCategories = ["All", "Web Apps", "Tools"]

  const filteredProjects =
    activeFilter === "All" ? projectsData : projectsData.filter((project) => project.category === activeFilter)

  return (
    <section className="min-h-screen bg-bg-primary px-[9%] py-[10rem] relative" id="projects">
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-[0] z-10">
        <svg
          className="relative block w-[calc(147%+1.3px)] h-[106px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M1200 0L0 0 598.97 114.72 1200 0z" className="fill-bg-secondary"></path>
        </svg>
      </div>

      <div className="flex flex-col justify-center items-center relative z-10 pb-[60px]">
        <div className="relative flex justify-center items-center flex-col w-full max-w-[1350px] pt-[70px] gap-3">
          <h2 className="text-[32px] md:text-[42px] text-center font-semibold mt-5 text-white font-rowdies">
            Projects
          </h2>
          <p className="text-[16px] md:text-[18px] text-center max-w-[600px] text-white mb-8">
            I have gained extensive expertise in web development through hands-on experience while working on various
            projects and these are the some projects I have worked on.
          </p>

          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-4 mb-4">
            {filterCategories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveFilter(category)}
                className={`px-6 py-3 rounded-full font-semibold text-[14px] md:text-[16px] transition-all duration-300 border-2 ${activeFilter === category
                  ? "bg-accent text-bg-primary border-accent shadow-[0_0_1rem_#59b2f4]"
                  : "bg-transparent text-white border-white hover:bg-accent hover:text-bg-primary hover:border-accent"
                  }`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Project Count */}
          <div className="text-center mb-8">
            <p className="text-accent text-[12px] font-semibold">
              Total Project{filteredProjects.length !== 1 ? "s" : ""} : {filteredProjects.length}
            </p>
          </div>

          {/* Projects Grid */}
          <div className="w-full max-w-[1200px] flex flex-wrap justify-center gap-[100px_30px] p-[100px_30px] px-4 py-20">
            {filteredProjects.map((project) => (
              <div
                key={project.id}
                className="relative flex justify-center items-start w-[300px] h-[295px] bg-bg-primary rounded-[20px] shadow-[0px_10px_15px_rgba(250,250,250,0.2)] transition-all duration-500 hover:h-[330px] group"
              >
                <div className="absolute top-5 w-[270px] h-[200px] bg-black rounded-[12px] overflow-hidden transition-all duration-500 group-hover:top-[-100px] group-hover:scale-75 group-hover:shadow-[0_15px_45px_rgba(0,0,0,0.2)]">
                  <img
                    src={project.image || "/placeholder.svg"}
                    alt={project.title}
                    className="absolute top-0 left-0 w-full h-full object-cover"
                  />
                </div>
                <div className="absolute top-[245px] w-full px-[30px] h-[30px] text-center overflow-hidden transition-all duration-500 group-hover:top-[125px] group-hover:h-[250px]">
                  <h2 className="font-bold text-[2.2em]" style={{ color: project.color }}>
                    {project.title}
                  </h2>
                  <p className="text-white text-[1.1em] mb-4">{project.description}</p>
                  <a
                    href={project.liveUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="relative top-[15px] inline-block px-[25px] py-3 font-semibold text-white rounded-lg text-[10px] transition-all duration-300"
                    style={{ backgroundColor: project.color }}
                  >
                    View Live App
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Projects